import type { LocalTime } from "@js-joda/core";
import type { FC } from "react";
import type { MyBusinessTimeOfDay } from "shared";
import type { UseFormReturn } from "../common/form/useForm";
import { ExtraForm } from "../common/pure/ExtraFormGroup";
import type { FormMyBusinessLocationFields } from "./FormBusinessLocationFields";
import styles from "./FormBusinessRegularHours.module.css";
import { LocalTimeToGoogleTime, timeOfDayToLocalTime } from "./helpers";
import { TimeRange } from "./TimeRange";

type Props = {
	form: UseFormReturn<FormMyBusinessLocationFields>;
};

export const FormBusinessRegularHours: FC<Props> = ({ form }) => {
	const handleTimeChange = (
		value: [LocalTime | null, LocalTime | null],
		formField: string,
	) => {
		const googleTime: [
			MyBusinessTimeOfDay | undefined,
			MyBusinessTimeOfDay | undefined,
		] = [
			value[0] ? LocalTimeToGoogleTime(value[0]) : undefined,
			value[1] ? LocalTimeToGoogleTime(value[1]) : undefined,
		];

		form.setFieldValue(formField, googleTime);
	};

	return (
		<div className={styles.list}>
			<ExtraForm.Group className={styles.day} label="Monday">
				<TimeRange
					value={[
						timeOfDayToLocalTime(form.values.monday?.[0]),
						timeOfDayToLocalTime(form.values.monday?.[1]),
					]}
					onChange={(value) => handleTimeChange(value, "monday")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group className={styles.day} label="Tuesday">
				<TimeRange
					value={[
						timeOfDayToLocalTime(form.values.tuesday?.[0]),
						timeOfDayToLocalTime(form.values.tuesday?.[1]),
					]}
					onChange={(value) => handleTimeChange(value, "tuesday")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group className={styles.day} label="Wednesday">
				<TimeRange
					value={[
						timeOfDayToLocalTime(form.values.wednesday?.[0]),
						timeOfDayToLocalTime(form.values.wednesday?.[1]),
					]}
					onChange={(value) => handleTimeChange(value, "wednesday")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group className={styles.day} label="Thursday">
				<TimeRange
					value={[
						timeOfDayToLocalTime(form.values.thursday?.[0]),
						timeOfDayToLocalTime(form.values.thursday?.[1]),
					]}
					onChange={(value) => handleTimeChange(value, "thursday")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group className={styles.day} label="Friday">
				<TimeRange
					value={[
						timeOfDayToLocalTime(form.values.friday?.[0]),
						timeOfDayToLocalTime(form.values.friday?.[1]),
					]}
					onChange={(value) => handleTimeChange(value, "friday")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group className={styles.day} label="Saturday">
				<TimeRange
					value={[
						timeOfDayToLocalTime(form.values.saturday?.[0]),
						timeOfDayToLocalTime(form.values.saturday?.[1]),
					]}
					onChange={(value) => handleTimeChange(value, "saturday")}
				/>
			</ExtraForm.Group>
			<ExtraForm.Group className={styles.day} label="Sunday">
				<TimeRange
					value={[
						timeOfDayToLocalTime(form.values.sunday?.[0]),
						timeOfDayToLocalTime(form.values.sunday?.[1]),
					]}
					onChange={(value) => handleTimeChange(value, "sunday")}
				/>
			</ExtraForm.Group>
		</div>
	);
};
